module.exports = __webpack_public_path__ + "media/images/landing-pages/studying-e2f5281058f93974ee1124c83c12d087.png";